import { Outlet } from "react-router-dom";

const StreetsLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default StreetsLayout;